<template>
	<div class="transcribing-icon">
		<div class="inner">
			<FontAwesomeIcon
				v-for="i in [0, 1, 2,]"
				:key="i"
				class="icon"
				:icon="[ `far`, `waveform-lines`]"
			/>
		</div>
	</div>
</template>

<script>

export default {
	name: "TranscribingIcon",
};
</script>

<style lang="scss" scoped>
.transcribing-icon {
	margin: 0;
	padding: 0;
}

@keyframes moveLeft {
	0% {
		transform: translateX(0%);
	}
	100% {
		transform: translateX(-200%);
	}
}

.transcribing-icon .inner {
	// TODO: this is not a scalable approach for this animation, but it will do for now
	width: 0.9101875rem; // 14.563px
	height: 0.9101875rem; // 14.563px

	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;

	overflow: hidden;

	border-radius: 0.5rem;
}

.transcribing-icon .icon {
	display: inline-block;
	transform: translateX(100%);
	animation-name: moveLeft;
	animation-duration: 1.5s;
	animation-direction: alternate;
	animation-timing-function: ease-in-out;
	animation-iteration-count: infinite;
}

</style>
